import { useInfiniteQuery } from '@tanstack/react-query'

import api from '@/api'

export const LIST_LAST_CUSTOM_SUMMARY_PROMPTS_KEY =
  'list-last-custom-summary-prompts'
export const LIST_TEAM_CUSTOM_SUMMARY_PROMPTS_KEY =
  'list-team-custom-summary-prompts'

export const useListLastCustomSummaryPrompts = () => {
  return useInfiniteQuery({
    queryKey: [LIST_LAST_CUSTOM_SUMMARY_PROMPTS_KEY],
    queryFn: async ({ pageParam = { skip: 0, limit: 10 } }) => {
      const data = await api.getCustomSummaryPrompts({
        skip: pageParam.skip,
        limit: pageParam.limit,
      })
      return data.data
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage.hasMore) return undefined

      // Calculate total items fetched so far
      const totalFetched = allPages.reduce(
        (sum, page) => sum + page.customSummaryPrompts.length,
        0,
      )

      // First page: 10 items, subsequent pages: 100 items
      const nextLimit = totalFetched === 10 ? 100 : 100

      return {
        skip: totalFetched,
        limit: nextLimit,
      }
    },
    initialPageParam: { skip: 0, limit: 10 },
    staleTime: 1000 * 20,
  })
}

export const useListTeamCustomSummaryPrompts = () => {
  return useInfiniteQuery({
    queryKey: [LIST_TEAM_CUSTOM_SUMMARY_PROMPTS_KEY],
    queryFn: async ({ pageParam = { skip: 0, limit: 10 } }) => {
      const data = await api.getTeamCustomSummaryPrompts({
        skip: pageParam.skip,
        limit: pageParam.limit,
      })
      return data.data
    },
    getNextPageParam: (lastPage, allPages) => {
      if (!lastPage.hasMore) return undefined

      // Calculate total items fetched so far
      const totalFetched = allPages.reduce(
        (sum, page) => sum + page.customSummaryPrompts.length,
        0,
      )

      // First page: 10 items, subsequent pages: 100 items
      const nextLimit = totalFetched === 10 ? 100 : 100

      return {
        skip: totalFetched,
        limit: nextLimit,
      }
    },
    initialPageParam: { skip: 0, limit: 10 },
    staleTime: 1000 * 20,
  })
}
